import globalconfig from '../../../common/config';


import RavenHistoryModal from '../modals/history/ravenHistory';
import DTCHistoryModal from '../modals/dtc/dtcHistory';
import TombstoneHistoryModal from '../modals/logs/tombstoneHistory';
import NotesModal from '../modals/notes/notesHistory';
import EventHistoryModal from '../modals/event/eventHistory';
import SupportedPidsModal from '../modals/dtc/supportedPids';
import BillingHistoryModal from '../../raven/modals/billing/billingHistory';
import UserViewModal from '../../raven/modals/user/userView';
import RavenViewStatusModal from '../modals/status/ravenStatusView';
import { DataBinsModal } from '../modals/datausage/dataBins';
import BtButtonModal from '../../raven/modals/btbutton';

const isPartner = globalconfig.features.ravens.vendorDetailsPreferred; // only partners get to see logs and notes

export const modalConfigs = [
    {
        url: 'history',
        title: 'Raven History',
        component: RavenHistoryModal,
        icon: '/images/ic_history_white_24dp_2x.png',
        tier: 1,
    },
    {
        url: 'dtc',
        title: 'DTC History',
        component: DTCHistoryModal,
        icon: '/images/car-engine-icon.png',
        tier: 1,
        callback: (unit, data) => unit.dtc = data,
    },
    ...(!isPartner ? [{
        url: 'logs',
        title: 'Log History',
        component: TombstoneHistoryModal,
        icon: '/images/tombstone-icon.png',
        tier: 2,
    },
    {
        url: 'notes',
        title: 'Notes',
        component: NotesModal,
        icon: '/images/baseline_sticky_note_2_white_24dp_2x.png',
        tier: 2,
        callback: (unit, data) => unit.notes = data,
    }] : []),
    {
        url: 'events',
        title: 'Event History',
        component: EventHistoryModal,
        icon: '/images/ic_event_note_white_24dp_2x.png',
        tier: 1,
    },
    {
        url: 'pids',
        title: 'Supported Pids',
        component: SupportedPidsModal,
        icon: '/images/supported-pids.png',
        tier: 1,
    },
    /*{
        url: 'billing',
        title: 'Billing', 
        component: BillingHistoryModal,
        icon: '/images/ic_assignment_white_24dp_2x.png',
        tier: 1,
    },This one doesn't seem to be in use*/ 
    /*{
        url: 'user/:userid',
        title: 'User View',
        component: UserViewModal,
        icon: null,
        tier: 1,
    }, This one needs a new endpoint. */
    {
        url: 'statushistory',
        title: 'Status History',
        component: RavenViewStatusModal,
        icon: '/images/test_2_rma.png',
        tier: 1,
    },
    ...(!isPartner ? [{
        url: 'btbutton',
        title: 'BT Button',
        component: BtButtonModal,
        icon: '/images/BT-Button-48x48.svg',
        tier: 1,
    }] : []),
    /*{
        url: 'databins',
        title: 'Data Usage',
        component: DataBinsModal,
        icon: '/images/baseline_show_chart_white_24dp_2x.png',
        tier: 1,
    } This one will take a bit to get working */
];
